import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

const headingModule = () => {

    const headings = document.querySelectorAll('.js-heading');

    headings.forEach(heading => {

        const splitText = new SplitText(heading, {
            type: "words",
            mask: "words",
        });

        const words = splitText.words;
        const animateDelay = parseFloat(heading.dataset.delay) || 0.1;

        console.log(animateDelay);

        gsap.set(heading, { opacity: 1 });

        ScrollTrigger.matchMedia({
            "(pointer: fine)": function() {

                gsap.set(words, {
                    yPercent: 100,
                    opacity: 0,
                });

                words.forEach((word, index) => {

                    word.classList.add('py-4');
                    word.parentElement.classList.add('-my-4');

                    gsap.to(word, {
                        duration: 1.2,
                        yPercent: 0,
                        opacity: 1,
                        ease: 'power3.inOut',
                        delay: index * animateDelay,
                        scrollTrigger: {
                            trigger: heading,
                            start: 'top 90%',
                            end: 'bottom bottom',
                        },

                    });

                });

            },
            "(pointer: coarse)": function() {

                gsap.set(words, {
                    yPercent: 0,
                    opacity: 1,
                });

            }
        });


    });

}

export default headingModule;